'use strict'
import { TweenMax } from 'gsap'

export default {
  initFade: function (className, duration) {
    TweenMax.set(className, { opacity: 0 })
    TweenMax.fromTo(className, duration, { opacity: 0 }, { opacity: 1 })
  }
}
